import singleSpaAngularJS from "single-spa-angularjs";
import {loadByOrder} from "@/spa/funcs.js";

const files = [
	["/callcenter/scripts/vendor.js"],
	[
		"/configFile.js?v=2",
		"/callcenter/scripts/templates.min.js",
		"/callcenter/scripts/html_scripts.js"
	]
];

const spaconf = {
	name: "callcenter",
	async load() {
		return loadByOrder(files);
	},
	getAppConfig() {
		return singleSpaAngularJS({
			angular: window.angular,
			domElementGetter: function() {
				let container = document.getElementById("spaContainer");
				return container;
			},
			mainAngularModule: "callcenter",
			uiRouter: true,
			preserveGlobal: true,
			template: `

    <div ui-view=""></div>
    `
		});
	}
};

export default spaconf;
